function documentText(value) {
  return String(value || '');
}

export function shouldHydrateCanvasDraftFromAuthoritative({
  canvasDraftEditing,
  currentDraftContent,
  existingSavedContent,
  lastHydratedAuthoritativeContent,
  nextAuthoritativeContent,
  preserveExistingOnEmptyAuthoritative,
} = {}) {
  const previousContent = documentText(lastHydratedAuthoritativeContent);
  const nextContent = documentText(nextAuthoritativeContent);
  const savedContent = documentText(existingSavedContent);
  if (preserveExistingOnEmptyAuthoritative && !nextContent && (savedContent || previousContent)) {
    return false;
  }
  if (nextContent === previousContent) {
    return false;
  }
  if (!canvasDraftEditing) {
    return true;
  }
  return documentText(currentDraftContent) === previousContent;
}

export default shouldHydrateCanvasDraftFromAuthoritative;
